import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActionButtonsComponent } from '../action-buttons/action-buttons.component';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  imports: [ActionButtonsComponent, MatDialogModule],
  templateUrl: './confirm-dialog.component.html'
})
export class ConfirmDialogComponent {
  @Input() title!: string;
  @Input() content!: string;
  @Input() confirmButtonTitle = 'Confirm';
  @Output() onConfirm = new EventEmitter();
  @Output() onCancel = new EventEmitter();

  constructor(
    private dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {}

  handleConfirm() {
    this.onConfirm.emit();
    this.dialogRef.close();
  }

  handleCancel() {
    this.onCancel.emit();
    this.dialogRef.close();
  }
}
